import { Box, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { useRedirect } from "react-admin";
import PropTypes from "prop-types";

import { ResourcesKeys } from "../../../enums";

const SalesHome = ({ redirectEnabled = false }) => {
  const redirect = useRedirect();

  useEffect(() => {
    if (redirectEnabled) redirect(`/${ResourcesKeys.CompanyProperties}`);
  }, []);

  return (
    <Box height="100%" display="flex" alignItems="center" justifyContent="center">
      <Typography>Welcome to sales dashboard</Typography>
    </Box>
  );
};

SalesHome.prototype = {
  redirectEnabled: PropTypes.bool,
};

export default SalesHome;
